/**
 * Media query matching Primer's `--viewportRange-narrow` custom media token
 * (`@media (max-width: calc(48rem - 0.02px))`), for the few call-sites in this
 * package that need the narrow/regular breakpoint in JS via `useMediaQuery`
 * instead of CSS (github/primer#6847). Expressed in rem (not a fixed pixel
 * value) so it stays in sync with the CSS breakpoint regardless of the user's
 * root font size.
 */
export const NARROW_VIEWPORT_MEDIA_QUERY = '(max-width: calc(48rem - 0.02px))'
